// extracted by mini-css-extract-plugin
export default {"container":"SBCInvoice_container__49Nrs","headerContainer":"SBCInvoice_headerContainer__PIEpb","listItem":"SBCInvoice_listItem__ePQya"};